"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var DividerHtmlRenderer = function DividerHtmlRenderer() {
  return React.createElement("hr", {
    className: "ory-plugins-content-divider"
  });
};

exports.default = DividerHtmlRenderer;